import Util from "@/util"
// ToolBar : Top positioned Toolbar
// @group DefaultLayout
export default {
    data () {
        return {
            locale: 'de',
            items: ['de', 'en'],
        }
    },
    watch: {
        locale (lang) {
            this.$i18n.locale = lang
            console.info('new language',  this.$i18n.locale);
            switch(lang) {
                case 'de':
                    console.info('language de')
                    this.$moment.locale('de-ch')
                    break;
                case 'en':
                    console.info('language en-gb')
                    this.$moment.locale('en-gb')
                    break;
                default:
                    console.info('default')
                    this.$moment.locale('de-ch')
            }
        }
    },
    created() {

    },
    computed: {
        toolbarLogo() {
            return "/static/svg/manor-logo.svg"
        },
    },
    methods: {
        handleDrawerToggle() {
            this.$emit("side-icon-click")
        },
        //------test-----
        onSettingsIconClick() {
            console.info('App-Toolbar: settings-icon-click', this);
            // window.dispatchEvent(new Event("settings-icon-click"));
            // this.$bus.$emit('settings-icon-click')
            this.$emit('settings-icon-click')

        },
        onFullScreenClick() {
            Util.toggleFullScreen()
        },
    },
}
